import React, {useState, useEffect} from 'react';
import {Link, useLocation, useHistory} from "react-router-dom";
import HeaderLogo from '../../components/HeaderLogo'
import Checkbox from '../../components/Checkbox';
import Button from '../../components/Button';
import Radio from '../../components/Radiobox';

import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import InfoIcon from '@material-ui/icons/Info';

const defaultService = [
    {
        name: "ปูกระเบื้อง (ไม่รวมรื้อ)",
        price: 0,
        unitPrice: 420,
        selected: false
    },
    {
        name: "ปูกระเบื้อง + รื้อ",
        price: 0,
        unitPrice: 150,
        selected: false
    },
    {
        name: "ปูกระเบื้อง (ไม่รวมรื้อ)",
        price: 0,
        unitPrice: 300,
        selected: false
    }
]
const withTileFloorService = [
    {
        name: "ปูกระเบื้อง (ไม่รวมรื้อ)",
        price: 0,
        startPrice: 6400,
        unitPrice: 420,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 6,400 บ.',
        description1: "ตร.ม. ถัดไป 420 บาท",
        mainservice: true
    },
    {
        name: "ปูกระเบื้อง + รื้อ",
        price: 0,
        startPrice: 7400,
        unitPrice: 550,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 7,400 บ.',
        description1: "ตร.ม. ถัดไป 550 บาท",
        mainservice: true
    },
    {
        name: "ทากันซึม",
        price: 0,
        unitPrice: 300,
        selected: false,
        notice: '(*แนะนำสำหรับพื้นที่ห้องน้ำ)',
        description1: "ค่าบริการ 300 บ./ตร.ม." ,
        mainservice: false
    },
    {
        name: "บริการปรับระดับพื้น 5-60 มม.",
        price: 0,
        unitPrice: 350,
        selected: false,
        description1: "ค่าบริการปรับระดับ 350 บ./ตร.ม." ,
        mainservice: false
    }
]
const withTileCeilingService = [
    {
        name: "ปูกระเบื้อง (ไม่รวมรื้อ)",
        price: 0,
        startPrice: 7100,
        unitPrice: 450,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 7,100 บ.',
        description1: "ตร.ม. ถัดไป 450 บาท",
        mainservice: true
    },
    {
        name: "ปูกระเบื้อง + รื้อ",
        price: 0,
        startPrice: 8100,
        unitPrice: 650,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 8,100 บ.',
        description1: "ตร.ม. ถัดไป 650 บาท",
        mainservice: true
    }
]
const noTileFloorService = [
    {
        name: "ปูกระเบื้อง (ไม่รวมรื้อ)",
        price: 0,
        startPrice: 9200,
        unitPrice: 800,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 9,200 บ.',
        description1: "ตร.ม. ถัดไป 800 บาท",
        mainservice: true
    },
    {
        name: "ปูกระเบื้อง + รื้อ",
        price: 0,
        startPrice: 10000,
        unitPrice: 950,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 10,000 บ.',
        description1: "ตร.ม. ถัดไป 950 บาท",
        mainservice: true
    },
    {
        name: "ทากันซึม",
        price: 0,
        unitPrice: 300,
        selected: false,
        notice: '(*แนะนำสำหรับพื้นที่ห้องน้ำ)',
        description1: "ค่าบริการทากันซึม 300 บ./ตร.ม." ,
        mainservice: false
    },
    {
        name: "บริการปรับระดับพื้น 5-60 มม.",
        price: 0,
        unitPrice: 350,
        selected: false,
        description1: "ค่าบริการปรับระดับ 350 บ./ตร.ม." ,
        mainservice: false
    }
]
const noTileCeilingService = [
    {
        name: "ปูกระเบื้อง (ไม่รวมรื้อ)",
        price: 0,
        startPrice: 9800,
        unitPrice: 825,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 9,800 บ.',
        description1: "ตร.ม. ถัดไป 825 บาท",
        mainservice: true
    },
    {
        name: "ปูกระเบื้อง + รื้อ",
        price: 0,
        startPrice: 11000,
        unitPrice: 1050,
        selected: false,
        notice: 'ขั้นต่ำ 10 ตร.ม. แรก 11,000 บ.',
        description1: "ตร.ม. ถัดไป 1,050 บาท",
        mainservice: true
    }
]

function CustomServicePage({details, serviceDetail, setServiceDetail, handleSummarySubmit}) {
  const [services, setServices] = useState([]);
  const [selected, setSelected] = useState(false);
  const [mustPreventLeak, setmustPreventLeak] = useState(false);
  const [totalArea, setTotalArea] = useState(0)
  const [calIndex, setCalIndex] = useState(0)
  const [calObject, setCalObject] = useState({})
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const location = useLocation();
  const history = useHistory();
  useEffect(()=>{
    if(!details) history.push('/')
    let tempServices, totalAreaCal
    if(details?.notile&&details?.areaType==='floor'){
        tempServices = [...noTileFloorService]
        if(details?.room==='restroom') {
            tempServices[2].selected = true
            setmustPreventLeak(true)
        }
    }
    else if(details?.notile&&details?.areaType==='ceiling'){
        tempServices = noTileCeilingService
    }
    else if(!details?.notile&&details?.areaType==='floor'){
        tempServices = withTileFloorService
        if(details?.room==='restroom') {
            tempServices[2].selected = true
            setmustPreventLeak(true)
        }
    }
    else if(!details?.notile&&details?.areaType==='ceiling'){
        tempServices = withTileCeilingService
    }
    else {
        history.push('/')
        return;
    }
    tempServices.map((service, index)=>{
        if(serviceDetail?.[index]?.selected||tempServices?.[index]?.selected) tempServices[index]['selected'] = true
        else tempServices[index]['selected'] = false
        const calArea = Math.ceil(details?.areaSize * (1 + details?.sparePercent/100))
        totalAreaCal = calArea
        if(service.mainservice){
            if(calArea<=10) {
                tempServices[index].price = tempServices[index].startPrice
            }
            else {
                tempServices[index].price = tempServices[index].startPrice + (calArea-10)*tempServices[index].unitPrice 
            }
            if(service.selected) setSelected(true)
        }
        else{
            if(calArea<=10) {
                tempServices[index].price = 10*tempServices[index].unitPrice
            }
            else{
                tempServices[index].price = calArea*tempServices[index].unitPrice
            }
        }
    })
    setServices(tempServices)
    setServiceDetail(tempServices)
    setTotalArea(totalAreaCal)
  },[])
  const handleSetService = (e, index) => {
    let tempServices = [...services]
    tempServices[index]['selected'] = e.target.checked
    if(index===0) {
        tempServices[1]['selected'] = false
    }
    else if(index===1) {
        tempServices[0]['selected'] = false
    }
    let tempselected = false
    tempServices.map((service, index)=>{
        if(service.selected&&service.mainservice) tempselected = true
    })
    setSelected(tempselected)
    setServices(tempServices)
    setServiceDetail(tempServices)
  }
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen2 = (num) => {
        let startPrice = services?.[num]?.['startPrice'],
        unitSqrm = totalArea > 10? totalArea - 10 : 0,
        unitPrice = totalArea > 10? (services?.[num]?.['unitPrice'] * (totalArea - 10)): 0,
        totalPrice = unitPrice + startPrice
        setCalIndex(num)
        setCalObject({
            spareSqrm: Math.ceil(details?.areaSize * details?.sparePercent/100),
            startPrice: startPrice.toLocaleString(),
            unitSqrm: unitSqrm,
            unitPrice: unitPrice.toLocaleString(),
            totalPrice: totalPrice.toLocaleString()
        })
        setOpen2(true);
    };
    const handleClose2 = () => {
        setOpen2(false);
    };
  const footerHeight = {height: document.getElementById('fix-footer')?.clientHeight}
  return (
    <div className="page-container">
        {/* <HeaderLogo /> */}
        <div className="flex row mainpadding">
            <Link to={
              location.pathname === "/tiles/notiles/services"
              ?"/tiles/notiles/question"
              :"/tiles/withtiles/question"
            } className="back-button">
                <div>{'< กลับ'}</div>
            </Link>
            <div className="bread-crump">
                <span className="h5 grey-text semibold">
                    รายละเอียด / <span className="green-text">เลือกบริการ</span> / สรุปข้อมูล
                </span>
            </div>
        </div>
        {/* <div className="cover-title-card box-shadow">
            {
                location.pathname === "/tiles/notiles/services"
                ?<div className="cover-header-container red-bg box-shadow h3">เลือกกระเบื้อง + หาช่าง</div>
                :<div className="cover-header-container red-bg box-shadow h3">หาช่างอย่างเดียว</div>
            }        
        </div> */}
        <Modal
          open={open}
          onClose={handleClose}
        >
          <div className='contact-modal'>
            <div className="flex row">
                <div className="tile-icon-wrapper">
                    <img style={{width: '50px'}} src="/asset/tileicon.png" />
                </div>
                <div className="h5 grey-text alight-left">*บริการดังกล่าวรวมวัสดุปูนกาว, ยาวแนว และปรับระดับพื้นไม่เกิน 5 มม. เรียบร้อยแล้ว</div>
            </div>
            <div className="h6"><br/></div>
            <div className="h1 bold">#ช่างถูกงานวัสดุถูกใจ</div>
            <div className="h5">มั่นใจงานปูกระเบื้องที่ได้มาตรฐานโดยทีมช่างมืออาชีพ 24 FIX พร้อมวัสดุปูกระเบื้องคุณภาพจากจระเข้</div>
            <img src="/asset/รวมผลิตภัณฑ์จระเข้.png" style={{width: '100%'}} />
            <div className="floating-kay" style={{bottom: 0, top: 'unset'}}>
                <img className="kay-container" src="/asset/kay.png" />
            </div>
            <div 
            className="close-modal-container red-text h1 bold"
            onClick={handleClose}
            >
                <CloseIcon/>
            </div>
          </div>
        </Modal>
        <Modal
          open={open2}
          onClose={handleClose2}
        >
          <div className='contact-modal'>
            <div className="h6"><br/></div>
            <div className="h1 bold">วิธีการคำนวณราคา</div>
            <div className="h5"><br/></div>
            {/* <div className="h5">มั่นใจงานปูกระเบื้องที่ได้มาตรฐานโดยทีมช่างมืออาชีพ 24 FIX พร้อมวัสดุปูกระเบื้องคุณภาพจากจระเข้</div> */}
            <table className="h5 alight-left cal-table">
                <tr>
                    <th style={{textAlign: 'center'}}>รายการ</th>
                    <th style={{textAlign: 'center'}}>พื้นที่</th>
                    <th style={{textAlign: 'center'}}>ราคา</th>
                </tr>
                <tr>
                    <td>พื้นที่ปูกระเบื้อง</td>
                    <td>{details?.areaSize} ตร.ม.</td>
                    <td></td>
                </tr>
                {
                    details?.sparePercent&&details?.sparePercent!=0?
                    <tr>
                        <td>สำรองเผื่อการติดตั้ง {details?.sparePercent}%<br/><span className="h6 red-text">*เศษของตารางเมตรคิดเป็น 1 ตร.ม.</span></td>
                        <td>{Math.ceil(details?.areaSize * details?.sparePercent/100)} ตร.ม.</td>
                        <td></td>
                    </tr>
                    :null
                }
                <tr>
                    <th>รวมพื้นที่</th>
                    <th>{totalArea} ตร.ม.</th>
                    <th></th>
                </tr>
                <tr>
                    <td>ขั้นต่ำ 10 ตร.ม. แรก<br/>เหมา {services?.[calIndex]?.['startPrice'].toLocaleString()} บ.</td>
                    <td>10 ตร.ม.</td>
                    <td className="alight-right">{calObject?.startPrice} บ.</td>
                </tr>
                {
                    totalArea > 10?
                    <tr>
                        <td>ตร.ม. ที่ 11 เป็นต้นไป<br/>{services?.[calIndex]?.['unitPrice'].toLocaleString()} บ./ตร.ม.</td>
                        <td>{calObject?.unitSqrm} ตร.ม.</td>
                        <td className="alight-right">{calObject?.unitPrice} บ.</td>
                    </tr>
                    :null
                }
                <tr>
                    <th>รวมราคา</th>
                    <th>{totalArea > 10 ? totalArea : 10} ตร.ม.</th>
                    <th className="alight-right">{calObject?.totalPrice} บ.</th>
                </tr>
                </table>
            <div className="floating-kay" style={{top: '36px'}}>
                <img className="kay-container" src="/asset/kay_float.png" />
            </div>
            <div 
            className="close-modal-container red-text h1 bold"
            onClick={handleClose2}
            >
                <CloseIcon/>
            </div>
          </div>
        </Modal>
        <div className="mainpadding">
            <div className="h1 bold">เลือกบริการ</div>
            <div className="h2 bold green-text alight-left" style={{marginTop: '10px'}}>รูปแบบการให้บริการ</div>
            <div className="h6"><br/></div>
            {
                services?.map((val, index)=>{
                    if(val.mainservice)
                    return(
                        <div className="service-checkbox-wrapper flex row" key={index}>
                            <Radio 
                                checked={services?.[index]?.selected} 
                                onChange={(e)=>handleSetService(e, index)}
                                style={{alignSelf: 'flex-start'}}  
                            />
                            <div className="service-checkbox-label alight-left">
                                <div className="h3 semibold">{services?.[index]?.['name']}<br/>{totalArea>10?totalArea:10} ตร.ม. <span className="info-icon-container" onClick={()=>handleOpen2(index)}><InfoIcon /></span></div>
                                {
                                    services?.[index]?.['notice']?
                                    <div className="h5 red-text">{services?.[index]?.['notice']}</div>
                                    :null
                                }
                                {  
                                    services?.[index]?.['description1']?
                                    <div className="h6">{services?.[index]?.['description1']}</div>
                                    :null
                                }
                            </div>
                            <div className="service-checkbox-price">
                                <div className="h3 semibold">{index===2?'+':null} ฿{services?.[index]?.['price'].toLocaleString()}</div>
                            </div>
                        </div>
                    )
                })
            }
            {
                details?.areaType==="floor"?
                <>
                    <div className="h2 bold green-text alight-left" style={{marginTop: '40px'}}>บริการเสริม</div>
                    <div className='extra-service'>
                        <div className="h6"><br/></div>
                        {
                            services?.map((val, index)=>{
                                if(!val.mainservice)
                                return(
                                    <div className="service-checkbox-wrapper flex row" key={index}>
                                        <Checkbox 
                                            checked={services?.[index]?.selected} 
                                            onChange={(e)=>handleSetService(e, index)}
                                            style={{alignSelf: 'flex-start'}}  
                                        />
                                        <div className="service-checkbox-label alight-left">
                                            <div className="h3 semibold">{services?.[index]?.['name']}</div>
                                            {  
                                                services?.[index]?.['notice']?
                                                <div className="h5 red-text">{services?.[index]?.['notice']}</div>
                                                :null
                                            }
                                            {  
                                                services?.[index]?.['description1']?
                                                <div className="h6">{services?.[index]?.['description1']}</div>
                                                :null
                                            }
                                        </div>
                                        <div className="service-checkbox-price">
                                            <div className="h3 semibold">+ ฿{services?.[index]?.['price'].toLocaleString()}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </>
                :null
            }
            <div style={footerHeight}></div>
        </div>
        <div id="fix-footer" className="service-footer-wrapper">
            <div className="tile-footer-wrapper flex row">
                <div className="tile-icon-wrapper">
                    <img style={{width: '50px'}} src="/asset/tileicon.png" />
                </div>
                <div className="h5 grey-text alight-left">*บริการดังกล่าวรวมวัสดุปูนกาว, ยาวแนว และปรับระดับพื้นไม่เกิน 5 มม. เรียบร้อยแล้ว</div>
                <div className="info-icon-container" onClick={handleOpen}><InfoIcon /></div>
            </div>
            <Button 
            fullWidth 
            text={'ประเมินราคา >'} 
            bigText={true}
            onPress={handleSummarySubmit}
            disabled={!selected}
            />
        </div>
    </div>
  );
}

export default CustomServicePage;
